/* global $, VARS, LOCATIONS */

import GoogleMapsLoader from 'google-maps';

let $map = null;
let $mapModal = null;
let $toggleMap = null;
let $results = null;
let $tooltip = null;
let $closeTooltip = null;
let $locationList = null;
const LOCATION_ITEM_SELECTOR = '.js-location-item';

const defaultMapOptions = {
  zoom: 12,
  fullscreenControl: false,
  streetViewControl: false,
  zoomControl: false,
  mapTypeControlOptions: {
    mapTypeIds: [],
  },
};

GoogleMapsLoader.KEY = VARS.GOOGLE_MAPS_KEY;
GoogleMapsLoader.VERSION = '3.44';

const map = {
  /**
   * Initialize map module
   *
   * @return {void}
   */
  initialize() {
    $map = $('.js-map');
    $mapModal = $('.js-map-modal');
    $toggleMap = $('.js-toggle-map');
    $results = $('.js-results');
    $tooltip = $('.js-map-tooltip');
    $closeTooltip = $('.js-map-tooltip-close');
    $locationList = $('.js-location-list');

    if (!$map.length) {
      return;
    }

    this.locations = [];
    this.markers = [];

    requestIdleCallback(() => {
      GoogleMapsLoader.load((google) => {
        this.google = google;
        this.buildMap();
        this.createListeners();
      });

      $closeTooltip.on('click', () => {
        $tooltip.fadeOut(200);

        this.unactivatePins();
        this.unactivateLocationItems();
      });
    });

    if ($toggleMap.length && $toggleMap[0].checked) {
      $mapModal.addClass('is-open');
      $results.addClass('is-open');
    }
  },

  createListeners() {
    $(window).on('render:map', () => {
      this.initialize();
    });

    $toggleMap.on('click', ({ currentTarget }) => {
      const isOpen = currentTarget.checked;

      $mapModal.toggleClass('is-open', isOpen);
      $results.toggleClass('is-open', isOpen);
    });

    $map.on('mouseenter', LOCATION_ITEM_SELECTOR, (e) => {
      const $target = $(e.currentTarget);
      const id = $target.data('id');

      const markerItem = this.markers.filter((currentMarker) => (
        currentMarker.location_id === parseInt(id, 10)
      ));

      this.activatePin(markerItem[0]);
    });

    this.markers.forEach((marker) => {
      marker.addListener('mouseover', () => {
        this.activatePin(marker);
        this.activateLocationItem(marker.location_id);
      });

      marker.addListener('mouseout', () => {
        $(LOCATION_ITEM_SELECTOR).removeClass('is-active');
      });
    });
  },

  /**
   * Create the map
   *
   * @return {void}
   */
  buildMap() {
    const mapEl = $map.get(0);
    const { latitude, longitude } = mapEl.dataset;

    this.map = new this.google.maps.Map(mapEl, {
      ...defaultMapOptions,
      center: {
        lat: parseFloat(latitude) || 52.2921331,
        lng: parseFloat(longitude) || 5.6167647,
      },
    });

    if (typeof LOCATIONS !== 'undefined' && Array.isArray(LOCATIONS)) {
      this.locations = LOCATIONS;
      this.addLocationsToMap();
    }
  },

  /**
   * Add the this.locations array to the map as markers
   *
   * @return {void}
   */
  addLocationsToMap() {
    this.locations.forEach((location) => {
      const marker = this.createMarkerForLocation(location);

      this.markers.push(marker);

      marker.addListener('click', () => {
        this.activatePin(marker);
        this.openWindow(location);
      });
    });
  },

  /**
   * Remove all markers from the map
   *
   * @return {void}
   */
  removeLocationsFromMap() {
    for (let i = 0; i < this.markers.length; i + 1) {
      this.markers[i].setMap(null);
    }

    this.markers = [];
  },

  /**
   * Create marker object for latitude and longitude
   *
   * @param {Object} data
   * @return {Object}
   */
  createMarkerForLocation({ id, latitude, longitude }) {
    return new this.google.maps.Marker({
      position: new this.google.maps.LatLng(latitude, longitude),
      icon: {
        url: '/front_assets/img/pin.svg',
        size: new this.google.maps.Size(34, 48),
        scaledSize: new this.google.maps.Size(34, 48),
      },
      map: this.map,
      location_id: id,
      originalLatitude: latitude,
      originalLongitude: longitude,
    });
  },

  /**
   * Open window on location
   *
   * @param {Object} location
   * @return {void}
   */
  openWindow(location) {
    Object.keys(location).forEach((key) => {
      const $output = $tooltip.find(`[data-output="${key}"]`);

      if (key === 'image') {
        $tooltip.find('img').attr('src', location[key]);
      }

      if ($output.length) {
        $output.html(location[key]);
      }
    });

    $tooltip.find('.js-tooltip-url').attr('href', location.slug);
    $tooltip.find('.btn').attr('href', location.route_url);

    $tooltip.fadeIn(200);
  },

  activatePin(marker) {
    this.unactivatePins();

    const icon = {
      url: '/front_assets/img/pin-active.svg',
      size: new this.google.maps.Size(34, 48),
      scaledSize: new this.google.maps.Size(34, 48),
    };

    marker.setIcon(icon);

    this.activateLocationItem(marker.location_id);
  },

  unactivatePins() {
    const defaultIcon = {
      url: '/front_assets/img/pin.svg',
      size: new this.google.maps.Size(34, 48),
      scaledSize: new this.google.maps.Size(34, 48),
    };

    this.markers.forEach((markerItem) => {
      markerItem.setIcon(defaultIcon);
    });
  },

  activateLocationItem(id) {
    this.unactivateLocationItems();

    $locationList
      .find(`${LOCATION_ITEM_SELECTOR}[data-id="${id}"]`)
      .addClass('is-active');
  },

  unactivateLocationItems() {
    $(LOCATION_ITEM_SELECTOR).removeClass('is-active');
  },
};

export default map;
